module.exports = __webpack_public_path__ + "static/img/04992845.4d117691.png";